

























































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AdditionalOptionsService } from "@/services/AdditionalOptions.service.ts";
import Number from "@/shared/filters/Number";
import { OptionItem } from "@/models/Coupon.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import DialogMasterCopy from "./components/DialogMasterCopy.vue";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import ComponentWithGroupShaten from '@/views/components/ComponentWithGroupShaten';
import { CommonService } from "@/services/Common.service";
/** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
import { SeibiService } from "@/services/Seibi.service";
/** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */

export interface OptionItemTb extends OptionItem {
  isEdit?: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable,
    DialogMasterCopy
  },
  mixins: [FilterSelectBox]
})
export default class AdditionalOptions extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;

  public groupDataList: any = [];
  public shatenDataList: any = [];
  public additionalOptionsService = new AdditionalOptionsService();
  public commonService = new CommonService();
  public optionData: OptionItem;
  public optionEdit: OptionItem;
  public additionalOptionsList: OptionItemTb[] = [];
  taxList: any = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;

  shouhizeiMarumeKbn: number = 0;
  environment: any;

  public dialogFormVisible: boolean = false;
  timerReOrder: any = null;
  public showAdditionalOptions: boolean = false;
  public showFlg: any = {
    displayCoupon: 0,
    displayProposal: 0,
    displayTokuten: 0,
    displayAdditionalOptions: 0
  };

  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
  public seibiService = new SeibiService();
  shuukeiDataList: any = [];
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */

  $refs!: {
    dialogCopy: DialogMasterCopy;
    inputZk: InputNumber;
  };

  public async getShowFlag() {
    const response = await this.additionalOptionsService.getShowFlag(this.form);
    if (response) {
      this.showFlg = response;
      this.$set(
        this,
        "showAdditionalOptions",
        this.showFlg.displayAdditionalOptions == 1 ? true : false
      );
    }
  }

  constructor() {
    super();

    this.optionData = {
      kyotenCd: "",
      optionNm: "",
      kingakuZk: 0,
      kingakuZn: 0,
      taxRate: null,
      displayOrder: null,
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
      shuukeiKbn: null,
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    };

    this.optionEdit = {
      kyotenCd: "",
      optionNm: "",
      kingakuZk: 0,
      kingakuZn: 0,
      taxRate: null,
      displayOrder: null,
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
      shuukeiKbn: null,
      /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    };
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.optionData.optionNm) {
      this.loading = true;
      const data = {
        ...this.optionData,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd
      };
      /** 2023-07-28 sh #8295(BQR1045) ommit shuukeiKbn. (temporary) [START] */
      delete data.shuukeiKbn;
      /** 2023-07-28 sh #8295(BQR1045) ommit shuukeiKbn. (temporary) [END] */
      this.addAdditionalOptionItem({ ...data });
      this.clearOptionData();
    }
  }

  async getMarumeKbn() {
    this.environment = await this.commonService.getEnvironment();
    if (this.environment) {
      this.shouhizeiMarumeKbn = this.environment.shouhizeiMarumeKbn;
    }
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenCd
    );
    this.getAdditionalOptionsList();
    this.delay(1000);
  }

  public async getAdditionalOptionsList(id?: number) {
    const response = await this.additionalOptionsService.getAdditionalOptions(this.form, id);
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "additionalOptionsList", [...data]);
    } else {
      this.$set(this, "additionalOptionsList", []);
    }
  }

  public async addAdditionalOptionItem(data: OptionItem) {
    const response = await this.additionalOptionsService.editAdditionalOptions(data);
    if (response) {
      this.getAdditionalOptionsList();
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public async delOptionItem(id: number) {
    this.loading = true;
    const response = await this.additionalOptionsService.deleteAdditionalOptions(id);
    if (response === 200) {
      this.getAdditionalOptionsList();
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.optionEdit = { ...rowData };
  }

  public editAdditionalOptionItem() {
    this.loading = true;
    if (this.optionEdit.id && this.optionEdit.optionNm) {
      const data = {
        id: this.optionEdit.id,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd,
        optionNm: this.optionEdit.optionNm,
        kingakuZk: this.optionEdit.kingakuZk,
        kingakuZn: this.optionEdit.kingakuZn,
        displayOrder: this.optionEdit.displayOrder,
        taxRate: this.optionEdit.taxRate
        /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
        , shuukeiKbn: this.optionEdit.shuukeiKbn
        /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
      };
      this.addAdditionalOptionItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private mounted() {
    this.getTaxList();
    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          this.getShowFlag();
          this.getAdditionalOptionsList();
          /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
          this.getMExpSeibiShuukeiKbn();
          /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
        });
      });
    });
    this.form.kyotenCd = localStorage.getItem("kyotenCd");
    this.getMarumeKbn();
  }

  public async getTaxList() {
    const response = await this.commonService.getTaxList();
    if (response) {
      this.$set(this, "taxList", response);
      this.setCurrentTaxRate();
    }
  }


  public getTaxRateLabel(item: any) {
      const tempTax: any = this.taxList.filter(
        (data: any) => data.rateExtremeType == item.taxRate
      );
      if (tempTax.length !== 0) {
        return tempTax[0].rateDecimal + '%';
      }

      return "不明";
  }

  get checkDisabledAdd() {
    let disabled = false;
    if (this.optionData.optionNm === "" || !this.optionData.kingakuZk ||
        !this.optionData.kingakuZn || !this.optionData.taxRate) {
      disabled = true;
    }
    return disabled;
  }

  get checkDisabledEdit() {
    let disabled = false;
    if (this.optionEdit.optionNm === "" || !this.optionEdit.kingakuZk ||
        !this.optionEdit.kingakuZn || !this.optionEdit.taxRate) {
      disabled = true;
    }
    return disabled;
  }

  clearOptionData() {
    this.optionData.optionNm = "";
    this.optionData.kingakuZk = null;
    this.optionData.kingakuZn = null;
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
    this.optionData.shuukeiKbn = null;
    /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */
    this.setCurrentTaxRate();
  }

  setCurrentTaxRate() {
    const tempTax: any = this.taxList.filter(
      (data: any) => data.isCurrent == 1
    );
    if (tempTax.length !== 0) {
      this.optionData.taxRate = tempTax[0].rateExtremeType;
    }
  }

  onEnd(event: any) {
    if (this.form.groupCd && this.form.shatenCd) {
      if (this.timerReOrder) {
        clearTimeout(this.timerReOrder);
        this.timerReOrder = null;
      }
      this.timerReOrder = setTimeout(() => {
        const data = this.additionalOptionsList.map((e: any) => {
          let item = {
            ...e,
          };
          delete item.isEdit;
          return item;
        });
        this.saveAdditionalOptionsList(data);
      }, 1000);
    }
  }

  public async saveAdditionalOptionsList(data: any) {
    const response = await this.additionalOptionsService.saveAdditionalOptions(data, this.form);
    if (response) {
      console.log(response);
    }
  }

  onOpenMasterCopy() {
    this.$refs.dialogCopy.open();
  }

  public async saveShowAdditionalOptions() {
    const response = await this.additionalOptionsService.saveShowAdditionalOptions({
      ...this.showFlg,
      displayAdditionalOptions: this.showAdditionalOptions ? 1 : 0,
      kyotenCd: this.form.kyotenCd
    });
    if (response) {
      console.log(response);
    }
  }

  onEnterZk() {
    this.$refs.inputZk.blur();
  }

  focusOutZn(isEdit: boolean) {
    this.focusOutPrice(isEdit, false);
  }

  focusOutZk(isEdit: boolean) {
    this.focusOutPrice(isEdit, true);
  }

  async focusOutPrice(isEdit: boolean, isZk: boolean) {
    let optionData: OptionItem = this.getOptionItem(isEdit);
    if (isZk) {
      if (optionData.kingakuZk) {
        let zn = await this.commonService.calcZeinuki(
          optionData.kingakuZk,
          optionData.taxRate,
          this.shouhizeiMarumeKbn
        );
        /** 2022-10-11 sh #8089(1053) fix typo. [START] */
        // this.$set(optionData, "kingakuZk", zn);
        this.$set(optionData, "kingakuZn", zn);
        /** 2022-10-11 sh #8089(1053) fix typo. [END] */
      } else {
        /** 2022-10-11 sh #8089(1053) fix typo. [START] */
        // this.$set(optionData, "kigakuZn", 0);
        this.$set(optionData, "kingakuZn", 0);
        /** 2022-10-11 sh #8089(1053) fix typo. [END] */
      }
    } else {
      if (optionData.kingakuZn) {
        let zk = await this.commonService.calcZeikomi(
          optionData.kingakuZn,
          optionData.taxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(optionData, "kingakuZk", zk);
      } else {
        /** 2022-10-11 sh #8089(1053) fix typo. [START] */
        // this.$set(optionData, "kigakuZn", 0);
        this.$set(optionData, "kingakuZn", 0);
        /** 2022-10-11 sh #8089(1053) fix typo. [END] */
      }
    }
  }

  getOptionItem(isEdit: boolean) {
    let optionData: OptionItem;
    if (isEdit) {
      optionData = this.optionEdit;
    } else {
      optionData = this.optionData;
    }
    return optionData;
  }

  get dialogEditTitle() {
    return this.title + ' 編集';
  }

  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [START] */
  async getMExpSeibiShuukeiKbn() {
    const res = await this.seibiService.getMExpSeibiShuukeiKbn();
    if (res) {
      this.shuukeiDataList = res;
    } else {
      this.shuukeiDataList = [];
    }
  }

  getShuukeiKbnLabel(item: any) {
    const tempShuukei: any = this.shuukeiDataList.filter(
      (data: any) => item.shuukeiKbn != null && data.shuukeiKbn == item.shuukeiKbn
    );
    if (tempShuukei.length !== 0 && tempShuukei.length > 0) {
      return tempShuukei[0].shuukeiKbnNm;
    }

    return '';
  }
  /** 2023-05-10 sh #8295(BQR1045) add shuukeiKbn to option. [END] */

}
